import { Routes, Route, Navigate } from "react-router-dom";
import { InstituteLogo } from "@/components/InstituteLogo";
import { INSTITUTE_NAME } from "@/lib/branding";
import { CourseView } from "@/pages/CourseView";
import { LessonView } from "@/pages/LessonView";
import { LessonPlayerScreen } from "@/components/LessonPlayerScreen";
import { PostAuthCourseRedirect } from "@/components/PostAuthCourseRedirect";
import { RequireLessonAuth } from "@/components/RequireLessonAuth";

const embedLesson =
  typeof window !== "undefined" && window.LP_LESSON?.slides?.length
    ? window.LP_LESSON
    : null;

/**
 * Course outline is public; lesson slides require a community session (see RequireLessonAuth).
 */
export function App() {
  return (
    <>
      <PostAuthCourseRedirect />
      <Routes>
        <Route path="/course/:courseId" element={<CourseView />} />
        <Route
          path="/course/:courseId/lesson/:lessonId"
          element={
            <RequireLessonAuth>
              <LessonView />
            </RequireLessonAuth>
          }
        />
        {embedLesson ? (
          <Route
            path="/"
            element={
              <RequireLessonAuth>
                <LessonPlayerScreen
                  lesson={embedLesson}
                  lessonId={typeof window !== "undefined" ? window.LP_LESSON_ID : undefined}
                  courseId={typeof window !== "undefined" ? window.LP_COURSE_ID : undefined}
                  ealLevel={typeof window !== "undefined" ? window.LP_EAL_LEVEL : undefined}
                />
              </RequireLessonAuth>
            }
          />
        ) : (
          <Route path="/" element={<HomeFallback />} />
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

function HomeFallback() {
  return (
    <div className="min-h-full flex flex-col items-center justify-center p-8 lp-theme-adult bg-gradient-to-b from-slate-50 to-indigo-50/40">
      <div className="mb-6 rounded-2xl bg-white p-4 shadow-lg shadow-indigo-100/60 ring-1 ring-slate-100">
        <InstituteLogo height={72} />
      </div>
      <p className="text-xs font-semibold uppercase tracking-widest text-indigo-600/90 mb-2">{INSTITUTE_NAME}</p>
      <p className="text-slate-600 text-center mb-6 max-w-md">
        Open a course from the main site, or use a direct link:
      </p>
      <p className="text-slate-500 text-sm text-center font-mono bg-white/70 rounded-xl px-4 py-3 ring-1 ring-slate-200/80">
        /course/:courseId — course outline
        <br />
        /course/:courseId/lesson/:lessonId — play a lesson
      </p>
    </div>
  );
}
